import React from 'react'

const IconAnalytics = (props) => {
  return (
    <svg {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2009_3470)">
        <path d="M35 39.9992V15" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M20 39.9988V0" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 39.9995V25" stroke="currentcolor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2009_3470">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconAnalytics